export const getVariantCookies = () => document.cookie.split('; ')
  .filter(row => row.startsWith('paper_monster_ab_test_') && row.endsWith('=true'))
  .map(row => row.split('=true')).map(r => r[0])

export const sendTransactionEvent = (order) => {
  if (window.gtag) {
    const itemName = `${order.plan.name} ${order.plan.frequency}`

    window.gtag('event', 'purchase', {
      transaction_id: order.id,
      value: order.plan.annualRecurringRevenue,
      items: [
        {
          item_id: itemName,
          item_name: itemName,
          item_category: 'checkout',
          price: order.plan.annualRecurringRevenue,
          quantity: 1,
        },
      ],
      ab_test_variant_pages_seen: getVariantCookies(),
    })
  }
}

export const googleAdsConversion = () => {
  if (window.gtag) {
    window.gtag('event', 'conversion', { send_to: 'AW-1071378145/kfEvCKqHrs8BEOHd7_4D' })
  }
}

export const bingConversionTracking = () => {
  window.uetq.push('event', 'FreeTrialFormSubmission', { event_category: 'FreeTrial', event_label: 'lead', event_value: '0' })
}

export const facebookTracking = (order) => {
  window.fbq('track', 'Purchase', { value: order.plan.amount, currency: 'USD' })
  window.fbq('track', 'StartTrial', { value: order.plan.amount, currency: 'USD', predicted_ltv: '0.00' })
}

export const fakePageView = () => {
  const args = { hitType: 'pageview', page: '/t/<?php echo $data["sku"]; ?>/order-success' }
  if (window.ga) {
    window.ga('send', args)
  } else {
    setTimeout(fakePageView, 200, args)
  }
}
